
import { useNavigate } from 'react-router-dom';
import HeaderContainer from '@/components/header/HeaderContainer';
import { FloatingCart } from '@/components/cart/FloatingCart';

const Header = () => {
  const navigate = useNavigate();

  const handleSearch = (searchTerm: string) => {
    console.log('Searching for:', searchTerm);
    // Navigate to products page with search parameter
    navigate(`/products?search=${encodeURIComponent(searchTerm)}`);
  };

  return (
    <>
      <HeaderContainer onSearch={handleSearch} />
      <FloatingCart />
    </>
  );
};

export default Header;
